// Free shipping progress bar
(() => {
  if (window.__freeShipEnhancerInit) return;
  window.__freeShipEnhancerInit = true;

  const ROOT_SEL = "[data-free-shipping]";
  const TEXT_SEL = "[data-free-shipping-text]";
  const BAR_SEL = "[data-free-shipping-bar]";

  function formatMoney(cents, currency) {
    const amount = cents / 100;
    return new Intl.NumberFormat("en-AU", {
      style: "currency",
      currency: currency || "AUD",
      minimumFractionDigits: 2
    }).format(amount);
  }

  function replaceToken(str, token, value) {
    return String(str).split(token).join(value);
  }

  function stripLeadingAmpersand(s) {
    const t = String(s || "").trim();
    return t.replace(/^&\s*/, "").trim();
  }

  function appendReward(baseText, rewardFragment) {
    const base = String(baseText || "").trim();
    const reward = String(rewardFragment || "").trim();
    if (!reward) return base;
    if (!base) return reward;

    const first = reward.charAt(0);
    if (first === "&") return `${base} ${reward}`;
    return `${base} & ${reward}`;
  }

  let controller = null;
  let seq = 0;
  let lastBarWidth = null;

  async function getCart() {
    if (controller) controller.abort();
    controller = new AbortController();

    const res = await fetch("/cart.js", {
      credentials: "same-origin",
      signal: controller.signal
    });

    if (!res.ok) throw new Error("Failed to fetch /cart.js");
    return res.json();
  }

  function updateFromCart(cart) {
    const els = Array.from(document.querySelectorAll(ROOT_SEL));
    if (els.length === 0) {
      lastBarWidth = null;
      return;
    }

    const subtotal = Number(cart.items_subtotal_price || 0);
    const currency = cart.currency || "AUD";

    for (const el of els) {
      const freeThreshold = parseInt(el.dataset.freeThresholdCents || "0", 10);
      const gwpThreshold = parseInt(el.dataset.gwpThresholdCents || "0", 10);

      const fsLockedTpl = el.dataset.fsMsgLocked || "Spend [[amount]] more for FREE Shipping!";
      const fsUnlockedTpl = el.dataset.fsMsgUnlocked || "You're eligible for FREE Shipping!";

      const rewardLockedAppend = (el.dataset.gwpLocked || "").trim();
      const rewardUnlockedAppend = (el.dataset.gwpUnlocked || rewardLockedAppend).trim();

      const rewardLockedFor = stripLeadingAmpersand(rewardLockedAppend);
      const rewardUnlockedFor = stripLeadingAmpersand(rewardUnlockedAppend);

      const gwpToggle = el.dataset.gwpEnabled === "true" || el.dataset.gwpEnabled === "1";
      const gwpEnabled = gwpToggle && gwpThreshold > 0 && rewardLockedAppend.length > 0;

      const freeRemaining = Math.max(0, freeThreshold - subtotal);
      const gwpRemaining = Math.max(0, gwpThreshold - subtotal);

      const freeUnlocked = freeThreshold > 0 && freeRemaining === 0;
      const gwpUnlocked = gwpEnabled && gwpRemaining === 0;

      const fsLockedText = replaceToken(fsLockedTpl, "[[amount]]", formatMoney(freeRemaining, currency));

      let text = "";

      if (!gwpEnabled) {
        text = freeUnlocked ? fsUnlockedTpl : fsLockedText;
      } else {
        if (freeThreshold === gwpThreshold) {
          if (freeUnlocked) {
            text = appendReward(fsUnlockedTpl, rewardUnlockedAppend);
          } else {
            text = appendReward(fsLockedText, rewardLockedAppend);
          }
        } else {
          if (freeUnlocked && gwpUnlocked) {
            text = appendReward(fsUnlockedTpl, rewardUnlockedAppend);
          } else if (freeUnlocked && !gwpUnlocked) {
            text = `${fsUnlockedTpl} Spend ${formatMoney(gwpRemaining, currency)} for ${rewardLockedFor}`;
          } else if (!freeUnlocked && gwpUnlocked) {
            text = `You've got ${rewardUnlockedFor} Spend ${formatMoney(freeRemaining, currency)} more for FREE Shipping`;
          } else {
            text = `Spend ${formatMoney(freeRemaining, currency)} more for FREE Shipping & ${formatMoney(
              gwpRemaining,
              currency
            )} for ${rewardLockedFor}`;
          }
        }
      }

      const textEl = el.querySelector(TEXT_SEL);
      const barEl = el.querySelector(BAR_SEL);

      if (textEl) textEl.textContent = text;

      if (barEl) {
        const target = gwpEnabled ? Math.max(freeThreshold, gwpThreshold) : freeThreshold;
        const pct = target > 0 ? Math.min(100, Math.floor((subtotal / target) * 100)) : 0;
        const done = gwpEnabled ? (freeUnlocked && gwpUnlocked) : freeUnlocked;

        barEl.style.width = `${done ? 100 : pct}%`;
        lastBarWidth = barEl.style.width;
      }
    }
  }

  let timers = [];

  async function run() {
    const mySeq = ++seq;
    try {
      const cart = await getCart();
      if (mySeq !== seq) return;
      updateFromCart(cart);
    } catch (e) {
      if (e && e.name === "AbortError") return;
      console.error("Free shipping progress error:", e);
    }
  }

  function trigger() {
    for (const id of timers) clearTimeout(id);
    timers = [];

    const delays = [0, 180, 450, 900, 1400];
    for (const d of delays) {
      timers.push(setTimeout(run, d));
    }
  }

  document.addEventListener("DOMContentLoaded", trigger);

  const mo = new MutationObserver((mutations) => {
    for (const m of mutations) {
      for (const node of m.addedNodes) {
        if (!(node instanceof HTMLElement)) continue;

        if (
          (node.matches && node.matches(ROOT_SEL)) ||
          (node.querySelector && node.querySelector(ROOT_SEL))
        ) {
          trigger();
        }

        if (!lastBarWidth) continue;

        const bars = [];
        if (node.matches && node.matches(BAR_SEL)) bars.push(node);
        if (node.querySelectorAll) bars.push(...node.querySelectorAll(BAR_SEL));

        for (const bar of bars) {
          if (bar.dataset.fsSeeded === "1") continue;

          bar.style.transition = "none";
          bar.style.width = lastBarWidth;
          bar.offsetWidth;
          bar.style.transition = "";
          bar.dataset.fsSeeded = "1";
        }
      }
    }
  });

  mo.observe(document.documentElement, { childList: true, subtree: true });

  document.addEventListener("click", (e) => {
    if (e.target && e.target.closest && e.target.closest(".cart-drawer")) trigger();
  });

  document.addEventListener("change", (e) => {
    if (e.target && e.target.closest && e.target.closest(".cart-drawer")) trigger();
  });

  document.addEventListener("input", (e) => {
    if (e.target && e.target.closest && e.target.closest(".cart-drawer")) trigger();
  });
})();